/**
 * Loader d'images pour l'export statique : Next.js n'applique pas basePath
 * aux src de next/image en mode unoptimized — ce loader prépose le basePath
 * (constaté sur la carte : miniatures 404 sans lui).
 * Aucune transformation d'image : les fichiers sont servis tels quels.
 */
import { BASE_PATH } from "./base-path";

export default function imageLoader({ src }: { src: string }): string {
  return src.startsWith("/") ? `${BASE_PATH}${src}` : src;
}
